// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var content = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(32), BsCssJs$PrezzeeRibbon.px(37)),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(32), BsCssJs$PrezzeeRibbon.px(66))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(65), BsCssJs$PrezzeeRibbon.px(55)),
            BsCssJs$PrezzeeRibbon.margin2("zero", "auto")
          ])
    ]);

var Styles = {
  content: content
};

function FullWidthCarousel__SlideContent(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    content,
                    className$1
                  ])
            });
}

var make = FullWidthCarousel__SlideContent;

export {
  Styles ,
  make ,
}
/* content Not a pure module */
